import React, { useEffect, useRef } from "react";
import { Card, Typography } from "antd";
import { motion } from "framer-motion";

const { Title } = Typography;

const TransactionList = ({ transactionDetails, renderTransactionItem }) => {
  const listVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  // Ref for scroll container
  const scrollRef = useRef(null);

  // Auto-scroll when transactionDetails change
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [transactionDetails]);

  return (
    <div style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Title level={4}>All Transactions</Title>

      <Card
        bodyStyle={{
          padding: 0,
          maxHeight: "86vh", // fix height for scrollable area
          overflowY: "auto",
        }}
        ref={scrollRef}
      >
        <motion.div
          variants={listVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          {transactionDetails.map((item, idx, arr) => (
            <motion.div key={idx} variants={itemVariants}>
              <div style={{ padding: "12px 16px" }}>
                {renderTransactionItem(item)}
              </div>
              {idx !== arr.length - 1 && (
                <div
                  style={{
                    borderBottom: "1px solid #f0f0f0",
                    margin: "0 16px",
                  }}
                />
              )}
            </motion.div>
          ))}
        </motion.div>
      </Card>
    </div>
  );
};

export default TransactionList;
